import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const alertsContactsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addEmailContacts',
        popover: {
          title: 'Add Email Contacts',
          description:
            'Click here to add email contacts to your list. This will allow you to send alerts and notifications directly to these contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.auvikMainTable',
        popover: {
          title: 'Auvik Network Overview',
          description:
            'This section shows the Auvik alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.poloAltoMainTable',
        popover: {
          title: 'Palo Alto Security Dashboard',
          description:
            'This section shows the Palo Alto alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.sientinalOneMainTable',
        popover: {
          title: 'SentinelOne Threat Monitoring',
          description:
            'This section shows the SentinelOne alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.siemMainTable',
        popover: {
          title: 'SIEM Event Analysis',
          description:
            'This section shows the SIEM alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.exabeamMainTable',
        popover: {
          title: 'Exabeam Alert',
          description: 'This section shows the Exabeam alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.msSentinelAlert',
        popover: {
          title: 'MS Sentinel Alert',
          description:
            'This section shows the MS Sentinel alert contacts.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default alertsContactsDriverObj;
